import { PAGE_CONTENT_ID_PREFIX } from '../constants';

/**
 * Generate the content page id used in analytics and customization api
 */
export function getContentPageId(id: string, slug?: string | null) {
    return `${PAGE_CONTENT_ID_PREFIX}${id || slug || ''}`;
}
